import { hasRole } from "@data/utility/ability"

// Qui a le chat du support dans l'app tuteur : le tuteur validé, c'est-à-dire le
// rôle `tutor`, que la validation de candidature pose à la place de
// `tutor-candidate` (TutorCandidateTrait::validateCandidature). Le candidat n'a
// pas de chat : il écrit au support par mail, depuis ses paramètres. Un compte
// qui porte aussi le rôle élève voit l'app élève (BottomTabsNavigator), dont le
// chat vit dans le mode parent.
export const hasTutorSupportChat = (user) =>
    !!hasRole(user, "tutor") && !hasRole(user, "student")

export const INTERCOM_SESSION = {
    IDENTIFIED: "identified",
    ANONYMOUS: "anonymous",
}

// La session que démarre IntercomChat. Une surface identifiée (mode parent, app
// tuteur) attend son jeton et ne retombe jamais sur une session anonyme : la
// personne écrirait sous un visiteur inconnu, hors de son contact. Seul le
// tunnel d'abonnement, où personne n'est encore connecté, démarre en anonyme.
export const intercomSession = ({ identified, alwaysShow, usableJwt }) => {
    if (identified) return usableJwt ? INTERCOM_SESSION.IDENTIFIED : null
    return alwaysShow ? INTERCOM_SESSION.ANONYMOUS : null
}

export const SUPPORT_REPLY_TARGET = {
    CURRENT_MODE: "current_mode",
    PARENT_MODE: "parent_mode",
}

// Où ouvrir la conversation quand on touche la notification de réponse du
// support. Le chat identifié est monté dans l'app tuteur et dans le mode
// parent : on y reste. Un compte élève passe d'abord en mode parent. Un compte
// tuteur sans chat (candidat) n'a nulle part où l'ouvrir.
export const supportReplyTarget = (user, isParentMode) => {
    if (isParentMode || hasTutorSupportChat(user)) {
        return SUPPORT_REPLY_TARGET.CURRENT_MODE
    }
    if (hasRole(user, "tutor") || hasRole(user, "tutor-candidate")) return null
    return SUPPORT_REPLY_TARGET.PARENT_MODE
}
